import { render } from "./CleanClothingSubsidy.vue?vue&type=template&id=00477252&scoped=true"
import script from "./CleanClothingSubsidy.vue?vue&type=script&lang=js"
export * from "./CleanClothingSubsidy.vue?vue&type=script&lang=js"

import "./CleanClothingSubsidy.vue?vue&type=style&index=0&id=00477252&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00477252"]])

export default __exports__